
export default {
  state: {
    slScroll: 0
  },
  getters: {
    slScroll: state => {
      return state.slScroll// 页面滚动的高度
    },
  },
  mutations: {
    SAVE_SL_SCROLL (state, val) {
      state.slScroll = val
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/clinical.js